module.exports = __webpack_public_path__ + "img/zhanbitu.ca201223.png";